module.exports = __webpack_public_path__ + "img/sable_logo.e1d60bb0.svg";